export default "__VITE_PUBLIC_ASSET__5aaf12d5__"